// setFirstShortMessagePlayed.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set first short message has played
 * @kind action
 * @param {boolean} {hasPlayed} - action param.
 * @return {Promise} Action promise.
 */
const setFirstShortMessagePlayed =
  ({ hasPlayed }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shorts'],
        data: {
          hasPlayed,
        },
      },
    });
  };

export default setFirstShortMessagePlayed;
